module.exports = __webpack_public_path__ + "assets/img/introduce.a4d5d689.png";